var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-item",style:(_vm.style),attrs:{"id":_vm.widget.object.wid}},[_c('TrafiklabViewer',{attrs:{"viewerStyles":_vm.widget.object.viewerStyles,"timetable":_vm.widget.object.timetable,"appId":_vm.widget.object.wid,"app":_vm.widget.object,"name":_vm.widget.object.name,"alt":"Trafiklab app"},on:{"saveData":_vm.saveAppData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }